import roles from '@/utils/roles'
import { tabsToRoutes } from '@/components/shared/tabs/utils'
import tabs from './tabs'

export default {
    path: '/manage/companies/:companyId',
    display: 'Manage Company',
    name: 'manage-company',
    props: true,
    component: () => import('./manage-company-page'),
    meta: {
        layout: 'app',
        roles: [roles.admin, roles.dataEntry, roles.matching, roles.inHouseDataEntry, roles.research],
    },
    children: tabsToRoutes(tabs),
}
